import React, { useState } from 'react';
import logoImg from '../assets/logo.png'; 
import { Linkedin, Activity } from 'lucide-react';

const FooterLink = ({ href, children }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <li style={{ marginBottom: '12px' }}>
      <a 
        href={href} 
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{ 
          color: isHovered ? 'white' : '#94a3b8', // Light Gray -> White on hover
          textDecoration: 'none',
          fontSize: '0.95rem',
          transition: 'color 0.2s ease',
          cursor: 'pointer'
        }}
      >
        {children}
      </a>
    </li>
  );
};

const Footer = ({ theme }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ 
      backgroundColor: '#0f172a', // Hardcoded Dark Slate (Guarantees contrast)
      color: '#94a3b8', 
      paddingTop: '80px', 
      paddingBottom: '40px', 
      borderTop: '1px solid #1e293b' 
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        
        {/* GRID LAYOUT */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '40px', marginBottom: '60px' }}>
          
          {/* COL 1: BRAND */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px', color: 'white', fontWeight: 'bold', fontSize: '1.4rem' }}>
               {/* Make sure logo.png is white or has a transparent background */}
               <img src={logoImg} alt="SiteACT" style={{ height: '32px', width: 'auto' }} />
               <span>SiteACT</span>
            </div>
            <p style={{ lineHeight: '1.6', fontSize: '0.95rem', marginBottom: '20px', color: '#94a3b8' }}>
              The operating system for modern construction compliance. Built for speed, designed for safety.
            </p>
            <div style={{ display: 'flex', gap: '15px' }}>
              <Linkedin size={20} style={{ cursor: 'pointer', color: 'white' }} />
              
              
            </div>
          </div>

          {/* COL 2: PRODUCT */}
          <div>
            <h4 style={{ color: 'white', marginBottom: '20px', fontSize: '1rem', fontWeight: 'bold' }}>Platform</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <FooterLink href="/permits">Permit to Work</FooterLink>
              <FooterLink href="/daily-log">Daily Work Log</FooterLink>
              <FooterLink href="/registry">Worker Registry</FooterLink>
              <FooterLink href="/assets">Asset Management</FooterLink>
              <FooterLink href="/audits">Safety Audits</FooterLink>
              <FooterLink href="/incidents">Incident Reporting</FooterLink>
              <FooterLink href="/corrective-actions">Corrective Actions</FooterLink>
              <FooterLink href="/inductions">Inductions & Training</FooterLink>
            </ul>
          </div>

          {/* COL 3: COMPANY */}
          <div>
            <h4 style={{ color: 'white', marginBottom: '20px', fontSize: '1rem', fontWeight: 'bold' }}>Company</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <FooterLink href="/about">About Us</FooterLink>
                <FooterLink href="/careers">Careers</FooterLink>
                <FooterLink href="/partners">Partners</FooterLink>
                <FooterLink href="/contact">Contact Sales</FooterLink>
            </ul>
          </div>

          {/* COL 4: LEGAL & STATUS */}
          <div>
            <h4 style={{ color: 'white', marginBottom: '20px', fontSize: '1rem', fontWeight: 'bold' }}>Compliance</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <FooterLink href="/privacy">Privacy Policy</FooterLink>
                <FooterLink href="/terms">Terms of Service</FooterLink>
                <FooterLink href="/gdpr">GDPR Statement</FooterLink>
                <FooterLink href="/security">Security Overview</FooterLink>
            </ul>
            
            {/* System Status Indicator */}
            <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.85rem', color: '#10b981' }}>
              <Activity size={16} />
              <span>All Systems Operational</span>
            </div>
          </div>
        </div>

        {/* BOTTOM BAR */}
        <div style={{ borderTop: '1px solid #334155', paddingTop: '30px', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '20px', fontSize: '0.9rem' }}>
          <div>&copy; {currentYear} SiteACT Systems Ltd. All rights reserved.</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            
            <span>London • Sofia</span>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;